export const EDIT_LOCATIONS_ACCESS = 'edit_locations_access';
